import React, { useState, useEffect } from 'react';
import axios from 'axios';
import "../covfile/Admin.css";

const API_URL = 'https://hub2.daolog.net/api';
const API_KEY = 'hshsahhahsn1991199nsns';

const AdminPanel = () => {
    const [verifiedUsers, setVerifiedUsers] = useState([]);
    const [pendingRequests, setPendingRequests] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedUser, setSelectedUser] = useState(null);
    const [customMessage, setCustomMessage] = useState('');
    const [searchUsername, setSearchUsername] = useState('');
    const [activeTab, setActiveTab] = useState('pending'); // 'pending' або 'verified'

    useEffect(() => {
        fetchAllData();
        
        // Оновлюємо дані кожні 30 секунд
        const interval = setInterval(fetchAllData, 30000);
        return () => clearInterval(interval);
    }, []);

    const fetchAllData = async () => {
        try {
            const response = await axios.get(`${API_URL}/admin-all-data`, {
                headers: { 'X-API-Key': API_KEY }
            });
            
            if (response.data.status === 'success') {
                setVerifiedUsers(response.data.verified_users || []);
                setPendingRequests(response.data.pending_requests || []);
            }
            setLoading(false);
        } catch (error) {
            console.error('Error fetching data:', error);
            alert('Помилка завантаження даних');
            setLoading(false);
        }
    };

    const approveUser = async (user) => {
        try {
            const response = await axios.post(`${API_URL}/approve-user/${user.user_id}`,
                { 
                    name: user.name,
                    username: user.username || ''
                },
                { headers: { 'X-API-Key': API_KEY } }
            );
            
            if (response.data.status === 'success') {
                alert('Користувача схвалено');
                fetchAllData(); // Оновлюємо дані
            }
        } catch (error) {
            console.error('Error approving user:', error);
            alert('Помилка схвалення користувача: ' + (error.response?.data?.message || error.message));
        }
    };

    const rejectUser = async (userId) => {
        if (!window.confirm('Ви впевнені, що хочете відхилити цього користувача?')) {
            return;
        }
        
        try {
            const response = await axios.post(`${API_URL}/reject-user/${userId}`,
                {},
                { headers: { 'X-API-Key': API_KEY } }
            );
            
            if (response.data.status === 'success') {
                alert('Користувача відхилено');
                fetchAllData(); // Оновлюємо дані
            }
        } catch (error) {
            console.error('Error rejecting user:', error);
            alert('Помилка відхилення користувача: ' + (error.response?.data?.message || error.message));
        }
    };

    const sendVerificationCode = async (userId) => {
        try {
            await axios.post(`${API_URL}/send-code`, 
                { userId },
                { headers: { 'X-API-Key': API_KEY } }
            );
            alert('Код верифікації надіслано');
        } catch (error) {
            console.error('Error sending code:', error);
            alert('Помилка надсилання коду: ' + (error.response?.data?.message || error.message));
        }
    };

    const sendCustomMessage = async () => {
        if (!selectedUser || !customMessage) {
            alert('Оберіть користувача та введіть повідомлення');
            return;
        }

        try {
            await axios.post(`${API_URL}/send-message`,
                { userId: selectedUser.user_id, message: customMessage },
                { headers: { 'X-API-Key': API_KEY } }
            );
            alert('Повідомлення надіслано');
            setCustomMessage('');
        } catch (error) {
            console.error('Error sending message:', error);
            alert('Помилка надсилання повідомлення');
        }
    };

    const searchUser = async () => {
        if (!searchUsername) return;

        try {
            const response = await axios.get(`${API_URL}/user/${searchUsername}`, {
                headers: { 'X-API-Key': API_KEY }
            });
            setSelectedUser(response.data.user);
        } catch (error) {
            console.error('Error searching user:', error);
            alert('Користувач не знайдений');
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'Невідомо';
        try {
            return new Date(dateString).toLocaleString('uk-UA');
        } catch {
            return 'Невідомо';
        }
    };

    if (loading) {
        return <div className="admin-panel-loading">Завантаження...</div>;
    }

    return (
        <div className="admin-panel-container">
            <h1 className="admin-panel-title">Адмін-панель верифікації</h1>

            {/* Таби перемикання */}
            <div className="admin-panel-tabs">
                <button 
                    className={`tab-btn ${activeTab === 'pending' ? 'active' : ''}`}
                    onClick={() => setActiveTab('pending')}
                >
                    Запити на верифікацію ({pendingRequests.length})
                </button>
                <button 
                    className={`tab-btn ${activeTab === 'verified' ? 'active' : ''}`}
                    onClick={() => setActiveTab('verified')}
                >
                    Верифіковані ({verifiedUsers.length})
                </button>
            </div>

            {/* Запити на верифікацію */}
            {activeTab === 'pending' && (
                <div className="admin-panel-users-section">
                    <h2 className="admin-panel-subtitle">Нові запити на верифікацію</h2>
                    {pendingRequests.length === 0 ? (
                        <p className="no-users-message">Немає нових запитів на верифікацію</p>
                    ) : (
                        <div className="admin-panel-table-wrapper">
                            <table className="admin-panel-table">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Ім'я</th>
                                        <th>Username</th>
                                        <th>Дата запиту</th>
                                        <th>Дії</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {pendingRequests.map(request => (
                                        <tr key={request.user_id}>
                                            <td data-label="ID">{request.user_id}</td>
                                            <td data-label="Ім'я">{request.name}</td>
                                            <td data-label="Username">@{request.username || 'немає'}</td>
                                            <td data-label="Дата запиту">{formatDate(request.requested_at)}</td>
                                            <td data-label="Дії">
                                                <button 
                                                    className="admin-panel-btn approve-btn" 
                                                    onClick={() => approveUser(request)}
                                                >
                                                    Схвалити
                                                </button>
                                                <button 
                                                    className="admin-panel-btn reject-btn" 
                                                    onClick={() => rejectUser(request.user_id)}
                                                >
                                                    Відхилити
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            )}

            {/* Верифіковані користувачі */}
            {activeTab === 'verified' && (
                <div className="admin-panel-users-section">
                    <h2 className="admin-panel-subtitle">Верифіковані користувачі</h2>
                    {verifiedUsers.length === 0 ? (
                        <p className="no-users-message">Немає верифікованих користувачів</p>
                    ) : (
                        <div className="admin-panel-table-wrapper">
                            <table className="admin-panel-table">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Ім'я</th>
                                        <th>Username</th>
                                        <th>Дата верифікації</th>
                                        <th>Дії</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {verifiedUsers.map(user => (
                                        <tr key={user.user_id}>
                                            <td data-label="ID">{user.user_id}</td>
                                            <td data-label="Ім'я">{user.name}</td>
                                            <td data-label="Username">@{user.username || 'немає'}</td>
                                            <td data-label="Дата верифікації">{formatDate(user.verification_date)}</td>
                                            <td data-label="Дії">
                                                <button 
                                                    className="admin-panel-btn" 
                                                    onClick={() => sendVerificationCode(user.user_id)}
                                                >
                                                    Надіслати код
                                                </button>
                                                <button 
                                                    className="admin-panel-btn select-btn"
                                                    onClick={() => setSelectedUser(user)}
                                                >
                                                    Обрати
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            )}

            {/* Секція пошуку та відправки повідомлень */}
            <div className="admin-panel-message-section">
                <h2 className="admin-panel-subtitle">Відправити повідомлення</h2>
                <div className="admin-panel-search">
                    <input
                        type="text"
                        placeholder="Пошук за username"
                        value={searchUsername}
                        onChange={(e) => setSearchUsername(e.target.value)}
                        className="admin-panel-input"
                    />
                    <button onClick={searchUser} className="admin-panel-btn">Знайти</button>
                </div>
                
                {selectedUser && (
                    <div className="admin-panel-message-form">
                        <p>
                            <strong>Обрано:</strong> {selectedUser.name} (ID: {selectedUser.user_id})
                            {selectedUser.username && `, @${selectedUser.username}`}
                        </p>
                        <textarea
                            value={customMessage}
                            onChange={(e) => setCustomMessage(e.target.value)}
                            placeholder="Введіть повідомлення"
                            rows="4"
                            className="admin-panel-textarea"
                        />
                        <div className="message-buttons">
                            <button onClick={sendCustomMessage} className="admin-panel-btn send-btn">
                                Відправити
                            </button>
                            <button 
                                onClick={() => {
                                    setSelectedUser(null);
                                    setCustomMessage('');
                                }} 
                                className="admin-panel-btn cancel-btn"
                            >
                                Скасувати
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default AdminPanel;